import axios from 'axios';
//import config from '../../config';
import {envConfig as config} from '../../environment';
import { NotificationManager } from 'react-notifications';
import { history } from '../../store';


axios.interceptors.response.use(response => {
   return response;
}, error => {
  if (error.response.status === 403) {
   console.log(" ****** ana hata yakalamayaya girdi 403");
   NotificationManager.error('Oturmun süresi doldu yeniden giriş yapmanız gerekiyor.' )    
    localStorage.removeItem("user");
    localStorage.removeItem("userToken");
    window.location.href =  config.mainPageUrl  //+ `?status=false&message=Oturmunuzun süresi dolmuştur. Yeniden giriş yapınız.&code=403`;
 //  history.push("/yts/403");
}
else if (error.response.status === 401) {
   console.log(" ****** ana hata yakalamayaya girdi 401");
   NotificationManager.error('Yetkisiz erişim' )     
   history.push("/401");
   return {status:false , data: null , messages : "Yetkisiz erişim"}
}
else
{
   history.push("/masal/404");
}

  return error;
});


export const postLoginUserApi = async(user)=>{
   const url = `${config.apiUrl}/v1/auth/login`;
   return await axios.post(url,user)
   .then(response => response.data)
}

export const postCreateUserApi = async(user)=>{
   const url = `${config.apiUrl}/v1/auth/signUp`;
   return await axios.post(url,user)
   .then(response => response.data)
}

export const postForgotMyPasswordUserApi = async(user)=>{
   const url = `${config.apiUrl}/v1/auth/forgotMyPassword`;
   return await axios.post(url,user)
   .then(response => response.data)
}

export const postResetPasswordUserApi = async(resetPaswordObject)=>{
   const url = `${config.apiUrl}/v1/auth/resetPasswordUser`;
   return await axios.post(url,resetPaswordObject)
   .then(response => response.data)
}
export const postActivationUserApi = async(activationObject)=>{
   const url = `${config.apiUrl}/v1/auth/activeUser`;
   return await axios.post(url,activationObject)
   .then(response => response.data)
}
